<ng-container *ngIf="!isAccepted">
  <nibtravel-alert
    class="alert-cookie"
    [withFlag]="false"
    [type]="alertType"
    [canBeClosed]="true"
    (alertClosed)="onAcceptOrClose()"
  >
    <span>
      <p id="alert-info-text" class="alert-info-text">
        We use cookies to help us improve website user experience. If you
        continue, we'll assume that you are happy for us to use cookies for this
        purpose.
        <br />
        <a class="link" target="_blank" href="{{ cookiePolicyLink }}">
          Cookie Policy.
        </a>
      </p>
      <p>
        <nibtravel-button
          size="sm"
          type="ghost"
          [e2eId]="e2eId.AcceptCookies"
          [text]="'Accept'"
          (btnClick)="onAcceptOrClose()"
        ></nibtravel-button>
      </p>
    </span>
  </nibtravel-alert>
</ng-container>
